import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {PeriodosContainer} from './Screen';

export const PeriodosView = () =>{

    return (
        <Page title={'Periodos'}>{<PeriodosContainer/>}</Page>
    )
}